/* @flow */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AudioTrack } from '../../base/media';
import { getLocalParticipant, getSortedParticipantJitsiIds } from '../../base/participants';
import { getPropertyValue } from '../../base/settings';
import { getAudioTrackInGroup } from '../../base/tracks';

function AudioTracksContainer(props) {
    const { remoteAudioTracks, volume, sharingVideo } = props;

    return (
        <div>
            {
                remoteAudioTracks.map(t => {
                    const { track, participantId } = t;
                    const audioTrackId = track && track.getId();
                    const id = `remoteAudio_${audioTrackId || ''}`;

                    return (
                        <AudioTrack
                            audioTrack = { t }
                            id = { id }
                            key = { id }
                            volume = { sharingVideo && sharingVideo.track_id === participantId ? 0 : volume }
                            participantId = { participantId } />);
                })
            }
        </div>);
}

function _mapStateToProps(state) {
    const audioTrack = getAudioTrackInGroup(state, false);
    const volume = getPropertyValue(state, "speakerVolume");
    const local = getLocalParticipant(state);
    const sharingVideo = state['features/screen-share'].sharingVideo;
    
    return {
        remoteAudioTracks: audioTrack,
        volume,
        sharingVideo: local.member_uuid === sharingVideo.member_uuid ? sharingVideo : null
    };
}

export default connect(_mapStateToProps)(AudioTracksContainer);